<template>
    <div class="tag-container align-items-end d-flex">
        <p class="tag caveat d-flex" v-if="ratesItem?.caveat?.description" v-tippy="customToolTipOptions">
            <i class="tag-icon fas d-md-flex fa-info-circle"></i>

            {{ ratesItem?.caveat?.description }}
        </p>
    </div>
</template>

<script>
export default {
    props: ['ratesItem'],
    data() {
        return {
            customToolTipOptions: {
                content: null,
                trigger: 'click',
                arrow: true,
                animation: 'scale',
            },
        }
    },
    created() {
        this.tooltipContentFill()
    },
    updated() {
        this.tooltipContentFill()
    },
    methods: {
        customToolTip: function () {
            return this.ratesItem?.caveat?.tooltip ? this.ratesItem?.caveat?.tooltip : null
        },
        tooltipContentFill: function () {
            this.customToolTipOptions.content = this.customToolTip()
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.tag-container {
    flex-wrap: wrap;

    .tag {
        background-color: var(--standard-tag-background-color);
        border-radius: 4px;
        color: var(--standard-tag-font-color);
        font-size: rem(12px);
        font-weight: bold;
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 4px 6px;

        &.caveat {
            cursor: pointer;
        }

        @media screen and (min-width: $bp-large) {
            padding: 4px;
        }

        .icon {
            margin-right: 5px;
            min-width: 14px;
            position: relative;
        }
    }

    .tag-icon {
        align-self: center;
        display: flex;
        font-size: rem(14px);
        margin-right: 5px;
    }
}
</style>
